const getAWSAmplifyRegion = (userPoolId: string): string => {
    return userPoolId.split(':')[0];
};

export default getAWSAmplifyRegion;